import API from '../../../lib/commons/api'
import {
  EvaluateProgressReportByTicketListRequest,
  EvaluateProgressReportByTicketListResult,
} from '../../../domain/entity/version-report/evaluation'

/**
 * チケット管理表別進捗状況の行（チケット管理表）ごとに、ステータスと定性コメントを AI に作らせる。
 * 管理表のチケットと、チケット配下のタスクの両方の進捗をもとにする。
 */
export const evaluateProgressByTicketList = async (
  request: EvaluateProgressReportByTicketListRequest
): Promise<EvaluateProgressReportByTicketListResult> => {
  const response = await API.functional.request(
    'POST',
    '/api/v1/projects/version-report/evaluate/progress-by-ticket-list',
    request
  )
  // 失敗すると共通 API クライアントは通知を出したうえで空の応答を返す。結果なしとして扱う
  const json =
    response.json as Partial<EvaluateProgressReportByTicketListResult>
  return { result: Array.isArray(json?.result) ? json.result : [] }
}
